module.exports = __webpack_public_path__ + "static/img/r_016.47aa378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_016.jpg
// module id = Beqj
// module chunks = 1